import makeAction from "./../../libs/actions";

export const playAction = makeAction("player/play");
export const pauseAction = makeAction("player/pause");
export const setTrack = makeAction("player/set_track");
export const setPlayerOptionsAction = makeAction("player/SET_OPTIONS");
